import { FormControl, Stack, TextField, Typography, Button, Autocomplete, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { v4 as uuidv4 } from 'uuid';
import { Fragment, useState } from "react";
import { useNavigate } from 'react-router-dom';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import './components/style.css';
import { useForm } from "../../hooks/useForm";
import useFetch from "../../hooks/useFetch";
import { urlGetNameClients, urlProduct } from "../../helpers";
import { DataForm } from "./components/DataForm";
import { PriceForm } from "./components/PriceForm";
import { messagesAddEstimate } from "../../helpers/estimateMessage";
import { Message } from "../../components/Message";

export const AddEstimate = () => {

    const { data: dataProduct } = useFetch(urlProduct, 'GET');
    const { data } = useFetch(urlGetNameClients, 'GET');

    const [formValues, handleInputChange, reset] = useForm({
        client: '', status: '', contact: '', tel: '', characteristics: '', date: '', dateCall: '', iva: '', paymentMethod: '', address: '', rents: [{ id: uuidv4(), measure: '', size: '', price: '', concept: '', rentsDays: '' }], rentsDays: '', firstDate: '', lastDate: '', paymentMethodRent: '', paymentMethodOptions: ''
    })

    const { client, firstDate, lastDate, status } = formValues;
    const [completeForm, setCompleteForm] = useState(null)
    const [closeMessage, setCloseMessage] = useState(true)

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/estimate')
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const id = data?.filter((el) => el.name === client)[0]?.id;
        setCompleteForm({ ...formValues, inputFields, 'clientId': id })
    }

    //form

    const [inputFields, setInputFields] = useState([
        { id: uuidv4(), product: '', amount: '', priceProduct: '' },
    ]);

    const handleChangeInput = (id, event) => {
        const newInputFields = inputFields.map(i => {

            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })

        setInputFields(newInputFields);
    }

    const handleReset = () => {
        setInputFields([{ id: uuidv4(), product: '', amount: '', priceProduct: '', measure: '' }]);
        reset()
    }

    const handleAddFields = () => {
        setInputFields([...inputFields, { id: uuidv4(), product: '', amount: '', priceProduct: '', measure: '' }])
    }

    const handleRemoveFields = id => {
        const values = [...inputFields];
        values.splice(values.findIndex(value => value.id === id), 1);
        setInputFields(values);
    }

    const onChange = (e) => {
        handleInputChange({
            target: {
                name: 'dates',
                value: e
            }
        })
    }

    return (
        <Fragment>
            {!completeForm ?
                <section className="section_formEstimate">
                    <FormControl component='form' className="form_containerEstimate" onSubmit={handleSubmit}>
                        <Stack spacing={3} pt={5} pb={4}>
                            <Typography textAlign='center' variant="h5" color="primary">Añadir nuevo Presupuesto</Typography>

                            <DataForm formValues={formValues} data={data} handleInputChange={handleInputChange} />

                            <Stack flexDirection='row' width='100%' justifyContent='space-around' flexWrap='wrap'  >
                                <Stack width='80%'>
                                    <Typography textAlign='center' mt='1rem' variant="subtitle" color="primary">Servicios</Typography>
                                </Stack>
                                <Stack width='100%' alignItems='center' mb='2rem'>
                                    {inputFields.map(inputField => (
                                        <Stack width='80%' alignItems='center' key={inputField.id} flexDirection='row' justifyContent='space-between'>
                                            {dataProduct &&
                                                <Autocomplete
                                                    disablePortal
                                                    options={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('')}
                                                    noOptionsText='Elige una opción correcta'
                                                    sx={{ width: '160px' }}
                                                    size='small'
                                                    value={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).includes(inputField.product) ? inputField.product : null}
                                                    onChange={(event, newValue) => {
                                                        handleChangeInput(inputField.id, { target: { name: 'product', value: newValue || '' } });
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Producto" variant="standard" required />}
                                                />}
                                            <Autocomplete
                                                disablePortal
                                                options={['m2', 'ud', 'm3', '']}
                                                sx={{ width: 130 }}
                                                size='small'
                                                value={['m2', 'ud', 'm3'].includes(inputField.measure) ? inputField.measure : null}
                                                onChange={(event, newValue) => {
                                                    handleChangeInput(inputField.id, { target: { name: 'measure', value: newValue || '' } });
                                                }}
                                                renderInput={(params) => <TextField {...params} label="Unidad" required variant="standard" />}
                                            />
                                            <TextField
                                                name="amount"
                                                label="Cantidad"
                                                variant="standard"
                                                value={inputField.amount}
                                                onChange={event => handleChangeInput(inputField.id, event)}
                                                type="number"
                                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                                sx={{ width: '100px' }}
                                                required
                                            />
                                            <TextField
                                                name="priceProduct"
                                                label="Precio/ud"
                                                variant="standard"
                                                value={inputField.priceProduct}
                                                onChange={event => handleChangeInput(inputField.id, event)}
                                                type="number"
                                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                                sx={{ width: '100px' }}
                                                required
                                            />
                                            <Stack direction='row'>
                                                <IconButton disabled={inputFields.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                                                    <DeleteIcon color='primary' />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleAddFields}
                                                >
                                                    <AddIcon />
                                                </IconButton>
                                            </Stack>
                                        </Stack>
                                    ))}
                                </Stack>

                                {
                                    status === 'Aceptado' &&
                                    <Stack flexDirection='row' width='100%' justifyContent='space-around' flexWrap='wrap'>
                                        <Stack flexDirection='row' width='80%' justifyContent='flex-start' gap={2} alignItems='flex-end' >
                                            <label >Fecha de alquiler:</label >
                                            <DateRangePicker required format='dd/MM/yyyy' onChange={onChange} value={[firstDate, lastDate] || ['', '']} />
                                        </Stack>
                                    </Stack>
                                }
                            </Stack>

                            <PriceForm dataProduct={dataProduct} formValues={formValues} handleInputChange={handleInputChange} />

                            <Stack flexDirection='row' pt='2rem' flexWrap='wrap' justifyContent='flex-end' width='90%' gap={8}>
                                <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={handleCancel}>Cancelar</Button>
                                <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={handleReset}>Reset</Button>
                                <Button sx={{ width: '100px' }} variant="contained" size='small' type='submit'>Añadir</Button>
                            </Stack>
                        </Stack>
                    </FormControl >
                </section>
                :
                <Fragment>
                    {closeMessage && <Message messages={messagesAddEstimate} method='POST' setIsCreate={setCloseMessage} body={completeForm} />}
                </Fragment>
            }

        </Fragment>
    )
}